import $ from 'jquery';

export default class Discover
{
	constructor()
	{
		this.$hidden_items = $('.discover-list__more'),
		this.$show_more = $('.discover-list__view_more');

		this.$show_more.on('click', this.click__show_more.bind(this));
	}

	click__show_more(ev)
	{
		ev.preventDefault();

		if (this.$hidden_items.hasClass('visually-hidden')) {
			this.$hidden_items.removeClass('visually-hidden');
			this.$hidden_items.slideDown(500);
			this.$show_more.text('View Less');
		} else {
			this.$hidden_items.slideUp(500, () => this.$hidden_items.addClass('visually-hidden'));
			this.$show_more.text('View More');
		}
	}
}
